// MLC-TAXHIST-001 — mirror of backend services/mlc_tax_history.py (display only;
// the server is authoritative and freezes the snapshot at Mail-Away send).
export const MLC_TAX_HISTORY_PRESETS = [
  { value: 'standard', label: 'Standard (current letter wording)' },
  { value: 'years:2', label: '2 Years Tax History' },
  { value: 'years:3', label: '3 Years Tax History' },
  { value: 'years:4', label: '4 Years Tax History' },
  { value: 'custom', label: 'Custom wording…' },
];

export const MLC_STANDARD_CURRENT_TAX_TEXT =
  'Kindly provide the current year tax details for the subject property, including base amount, amount paid, paid date, and due date.';

const WORDS = { 2: 'two', 3: 'three', 4: 'four' };

export const mlcTaxHistoryLetterText = (years) =>
  `Please provide the current tax information along with the prior ${WORDS[years] || years} years of tax history for the subject property, including the tax year, base amount, amount paid, paid date, due date, and any outstanding or delinquent amounts.`;

export const CUSTOM_TEXT_MIN = 20;
export const CUSTOM_TEXT_MAX = 600;

// {mode, years, custom_text} → select value
export const configToPreset = (cfg) => {
  if (!cfg || !cfg.mode || cfg.mode === 'standard') return 'standard';
  if (cfg.mode === 'years') return `years:${cfg.years}`;
  return 'custom';
};

// select value + custom text → {mode, years, custom_text} | null (standard)
export const presetToConfig = (preset, customText) => {
  if (!preset || preset === 'standard') return { mode: 'standard', years: null, custom_text: null };
  if (preset.startsWith('years:')) return { mode: 'years', years: parseInt(preset.split(':')[1], 10), custom_text: null };
  return { mode: 'custom', years: null, custom_text: (customText || '').trim() };
};

export const previewLetterText = (preset, customText) => {
  if (!preset || preset === 'standard') return MLC_STANDARD_CURRENT_TAX_TEXT;
  if (preset.startsWith('years:')) return mlcTaxHistoryLetterText(parseInt(preset.split(':')[1], 10));
  return (customText || '').trim();
};
